import React          from 'react';
import classNames     from 'classnames';
import * as PropTypes from 'prop-types';

import { RenderDoubleButton } from '../buttons/base/RenderDoubleButton';

const RenderHeaderTabs = (props) => {
  const {
          active,
          nav,
          onChange,
        } = props;

  return (
    <div>
      <RenderDoubleButton>
        {nav.map((tab, t) => (
          <span
            key={t}
            className={classNames('btn', { 'active': t === active })}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onChange(t);
            }
            }
          >{tab.label}</span>
        ))}
      </RenderDoubleButton>
    </div>
  );
};

RenderHeaderTabs.defaultProps = {
  active: 0,
};
RenderHeaderTabs.propTypes    = {
  active:   PropTypes.number,
  nav:      PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RenderHeaderTabs;